import { Component, HostBinding } from '@angular/core';
import {
  FieldType,
  FormlyExtension,
  FormlyFieldConfig
} from '@ngx-formly/core';
import { isValid, parseISO } from 'date-fns';
import {
  sharedCountOfEducableChildren,
  sharedPersonalInformation
} from '../../form-parts-definition';
import { sharedPersonalInformation2026 } from '../../form-parts-definition_2026';

@Component({
  selector: 'tpa-personal-info-2026',
  templateUrl: 'personal-2026.component.html',
  // TODO: TPA : Uncomment this
  // host: { class: 'tpa-wrapper__control' },
})
export class PersonalInfo2026Component
  extends FieldType
  implements FormlyExtension {
  defaultOptions = {
    className: 'p-col-12',
    props: {
      translate: true,
      full: true,
      open: false,
    },
  };

  // get emptyModel() {
  //   return !this.model || JSON.stringify(this.model) === '{}';
  // }
  parseISO = parseISO;
  isValid = isValid;

  @HostBinding('class.p-grid') someField = true;

  onPopulate(field: FormlyFieldConfig) {
    if (field.fieldGroup) {
      return;
    }

    field.fieldGroup = [
      ...sharedPersonalInformation2026(),
      sharedCountOfEducableChildren(),
    ];
  }
}
